import { post } from './fetch'


export const getTotalFillRate = (lastDays) => {
    return post('/api/manager/fillrate/total' , {lastDays} , true);
}

export const getMarketsFillRate = (categoryid = undefined, lastDays) => {
    return post('/api/manager/fillrate/markets' , {categoryid, lastDays} , true);
}

export const getCategoriesFillRate = (marketid = undefined, lastDays) => {
    return post('/api/manager/fillrate/categories' , {marketid, lastDays} , true);
}
